import * as Sentry from "@sentry/react";
import {
  browserTracingIntegration,
  replayIntegration
} from "@sentry/browser";

Sentry.init({
  dsn: "https://0d6a7e1cdccf46ee7280e03f57c71aed@sentry.adverton.pro/5",
  environment: __ENVIRONMENT__,
  // Актуальные интеграции
  integrations: [
    browserTracingIntegration({
      tracePropagationTargets: [
        "localhost",
        "https://test.admin.adverton.pro/tmc",
        "https://test.admin.adverton.kz/tmc",
        "https://stage.admin.adverton.pro/tmc"],
    }),
    replayIntegration(),
  ],
  beforeSend(event) {
    // const traceId = Sentry?.getCurrentHub()?.getScope()?.getSpan()?.traceId;
    const traceId =
      Sentry.getActiveSpan()?.spanContext().traceId ||
      window.crypto?.randomUUID() ||
      Date.now().toString(36);

    // Добавляем traceId в теги и контекст
    event.tags = {...event.tags, trace_id: traceId};
    event.extra = {...event.extra, traceId: traceId};

    console.log("Trace ID (Sentry)1:", Sentry.getActiveSpan()?.spanContext().traceId);
    console.log("Trace ID (Sentry)2:", window.crypto?.randomUUID());
    console.log("Trace ID (Sentry)3:", Date.now().toString(36));

    return event;
  },
  // Настройки трассировки
  // tracesSampleRate: __NODE_ENV__ === 'development' ? 1.0 : 0.1, // Для продакшена лучше уменьшить (0.1)
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  enabled: true,
  // environment: process.env.NODE_ENV,
  release: __RELEASE_VERSION__,

  // Настройки replays (если используется)
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1.0,
});